import { keyframes } from "styled-components";

export const bounceAnimation = (offset, unit = 'rem') => {
    return keyframes `
        0%   { transform: translateY(0); }
        50%  { transform: translateY(${offset + unit}); }
        100% { transform: translateY(0); }
    `
}


export const moveElementHorizontally = ({ x1, x2, unit = 'rem' }) => {
    return keyframes`
        0% {transform: translateX(${(x1 + unit)} ); }
        100% {transform: translateX(${x2 + unit}); }
    `
}

export const moveElementVertically = ({ y1, y2, unit = 'rem' }) => {
    return keyframes`
        0% {transform: translateY(${(y1 + unit)} ); }
        100% {transform: translateY(${y2 + unit}); }
    `
}